<template>
  <div>
    <div style="width: 100%; padding: 4px">
      <span class="title" style="font-size: 28px;">lib</span>
      <span class="title">a document store</span>
      <span class="actions">
        <button @click="sidebarOn = false">
          <md-icon style="color:#ddd">menu</md-icon>
        </button>
      </span>
    </div>
    <div v-if="!jwt" id="login">
      <input
        v-model="email"
        type="text"
        title="email"
        placeholder="email"
        size="30"
        class="left"
        autofocus
      />
      <input
        v-model="password"
        @keydown.enter="login({ email, password })"
        type="password"
        title="password"
        placeholder="password"
        size="22"
        class="middle"
      />
      <button @click="login({ email, password })" class="right">login</button>
    </div>
    <div v-else style="width: 100%;">
      <br />
      <Repl />
      <div id="nav">
        <router-link to="/">Home</router-link> |
        <router-link to="/about">About</router-link> |
        <a @click="logout">logout</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Repl from '@/components/repl'

export default {
  components: {
    Repl,
  },

  computed: {
    ...mapState({
      jwt: state => state.account.jwt,
      name: state => state.account.name,
    }),

    sidebarOn: {
      get: function() {
        return this.$store.state.settings.sidebarOn
      },
      set: function(val) {
        this.$store.state.settings.sidebarOn = val
      },
    },
  },

  data() {
    return {
      email: '',
      password: '',
    }
  },

  methods: {
    ...mapActions({
      login: 'account/login',
      logout: 'account/logout',
    }),

    logout() {
      localStorage.removeItem('jwt')
      window.location.reload()
    },
  },
}
</script>

<style scoped>
.title {
  font-size: 20px;
  font-weight: bold;
  color: #789;
}

#login {
  padding: 2%;
  text-align: left;
}

input {
  min-height: 25px;
}

.left {
  max-width: 95%;
  border-top: solid 2px #34abe6;
  border-right: solid 1px #34abe6;
  border-bottom: solid 1px #444;
  border-left: solid 1px blue;
  border-radius: 5px 5px 0 0;
  padding-left: 4px;
  font-weight: bold;
  font-size: 12px;
}

.middle {
  width: 72%;
  border-top: solid 1px white;
  border-right: solid 1px #34abe6;
  border-bottom: solid 1px #34abe6;
  border-left: solid 1px #34abe6;
  border-radius: 0 0 0 5px;
  padding-left: 4px;
  font-weight: bold;
  font-size: 12px;
}

.right {
  width: 12%;
  min-height: 24px;
  width: 20%;
  border: solid 1px #aecaff;
  border-radius: 0 0 5px 0;
  background-color: #ccc;
  font-weight: bold;
  font-size: 12px;
}
#nav {
  padding: 4px;
}
</style>
